<!-- <div class="modal-content contact-modal"> -->
  <div class="contact-modals">
  <div class="modal-header py-2">
    <button type="button" class="close pull-right py-1" aria-label="Close" (click)="hide()" style="top: 20px;">
      <i class="fas fa-times"></i>
    </button>
    <h4 class="modal-title w-100" id="myModalLabel">Contact Us</h4>
  </div>
  <div class="modal-body" style="background: #fff;">

    <div class="row mx-0 my-2 border-bottom" style="border-color: #b6b9bd !important;">
      <div class="d-none mx-lg-auto mx-xl-0">
        <img src="../assets/img/support.png" style="width: 250px; max-width: 100%;">
      </div>
      <div class="col-lg-6 col-md-6 col-12 SR-block pt-lg-0 pt-3 pb-3"
        [ngClass]="isMobile || isTablet?'custom-contact-border':''">
        <div class="w-100 title-top">
          <p class="font-weight-bold customBold">I.T Support</p>
        </div>
        <div class="contact mt-0">
          <i class="fas fa-user support_icon"></i>
          <p>Support:</p>
        </div>
        <div class="contact">
          <i class="fas fa-envelope support_icon"></i>
          <p style="word-break: break-all; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"><a
              href="{{'mailto:' + 'help&#64;milescpacredits.com'}}" title="help&#64;milescpacredits.com">help&#64;milescpacredits.com</a></p>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-12 SPOC-block pt-lg-0 pt-3 pb-3"
        [ngClass]="isMobile || isTablet?' custom-contact-border':''">
        <div class="w-100 title-top">
          <p class="font-weight-bold customBold">Academic Support Escalation</p>
        </div>
        <div class="contact mt-0">
          <i class="fas fa-user support_icon"></i>
          <p>Anupama Kotturi <span>(CPA)</span></p>
        </div>
        <div class="contact">
          <i class="fas fa-envelope support_icon"></i>
          <p style="word-break: break-all; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"><a
              href="{{'mailto:' +' anupama.kotturi&#64;mileseducation.com'}}" title="anupama.kotturi&#64;mileseducation.com">anupama.kotturi&#64;mileseducation.com</a></p>
        </div>
      </div>
    </div>

    <div class="row mx-0 my-2" [ngClass]="isMobile || isTablet?'px-0 pb-0 z-depth-0':''">

      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pt-lg-0 pt-3 pb-3"
        [ngClass]="isMobile || isTablet?'custom-contact-border':''">
        <div class="w-100">
          <p class="font-weight-bold customBold">Tech Support Escalation: Level 1</p>
        </div>
        <ng-container>
          <div class="contact">
            <i class="fas fa-user support_icon"></i>
            <p>Chakradhar Gollupadi</p>
          </div>
          <div class="contact">
            <i class="fas fa-envelope support_icon"></i>
            <p style="word-break: break-all; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"><a
                href="mailto:chakradhar.gollupadi&#64;mileseducation.com" title="chakradhar.gollupadi&#64;mileseducation.com">chakradhar.gollupadi&#64;mileseducation.com</a></p>
          </div>
        </ng-container>
      </div>

      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pt-lg-0 pt-3 pb-3"
        [ngClass]="isMobile || isTablet?'custom-contact-border':''">
        <div class="w-100">
          <p class="font-weight-bold customBold">Tech Support Escalation: Level 2</p>
        </div>
        <ng-container>

          <div class="contact">
            <i class="fas fa-user support_icon"></i>
            <p>Shamantha Kali Sekar</p>
          </div>
          <div class="contact">
            <i class="fas fa-envelope support_icon"></i>
            <p style="word-break: break-all; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"><a
                href="mailto:shamantha.sekar&#64;mileseducation.com" title="shamantha.sekar&#64;mileseducation.com">shamantha.sekar&#64;mileseducation.com</a></p>
          </div>
        </ng-container>

      </div>
    </div>
  </div>
</div>